var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8509 8.58245H5.85926M8.35437 11.0782L8.35489 6.08655M8.3551 15.7134C4.41677 15.7134 1.22412 12.5207 1.22412 8.58239C1.22412 4.64406 4.41677 1.45142 8.3551 1.45142C12.2934 1.45142 15.4861 4.64406 15.4861 8.58239C15.4861 12.5207 12.2934 15.7134 8.3551 15.7134Z",
    stroke: "#666970",
    strokeWidth: 1.4262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusGray);
export default __webpack_public_path__ + "static/media/CirclePlusGray.18ba4d3b56627e1698c0f3dfbc9e157e.svg";
export { ForwardRef as ReactComponent };